<div class="d-flex flex-wrap align-items-center">
	<img width="{{ size }}" height="auto" class="me-2" [src]="clientLogoSrc" alt="client logo" *ngIf="clientLogoSrc" />
	<div>{{ clientName }}</div>
	<div class="text-muted ms-2" *ngIf="showPlan && planName">- {{ planName }}</div>
</div>
